import { Guid, Nillable } from '@web/utils';
import { PublicBoxComponentGroupCosmetic } from './public-box-component-group-cosmetic';

export class PublicBoxComponentGroup {
  public constructor(
    private readonly data: {
      cosmetics: PublicBoxComponentGroupCosmetic[];
      id: Guid;
      isVisibleInQuestionnaire: boolean;
      description?: Nillable<string>;
    },
  ) {}

  public get cosmetics(): PublicBoxComponentGroupCosmetic[] {
    return this.data.cosmetics;
  }

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isVisibleInQuestionnaire(): boolean {
    return this.data.isVisibleInQuestionnaire;
  }
}
